import { create } from 'zustand';

/**
 * Globalna zahteva »dodaj v canvas« (seja 311). Hover kartice živijo v Radix
 * portalih, ki se ob premiku miške ODKLOPIJO — dialog, odprt znotraj kartice,
 * bi izginil z njo. Zato gumb v kartici samo odda zahtevo sem, dialog pa
 * izriše CanvasPickerHost, vpet enkrat v korenski layout (preživi kartico).
 */
export interface CanvasPickerRequest {
  html: string;
  sourceLabel: string;
}

interface CanvasPickerState {
  request: CanvasPickerRequest | null;
  openPicker: (request: CanvasPickerRequest) => void;
  closePicker: () => void;
}

export const useCanvasPickerStore = create<CanvasPickerState>((set) => ({
  request: null,
  openPicker: (request) => set({ request }),
  closePicker: () => set({ request: null }),
}));
